import React from 'react';
import { string, shape, arrayOf, func, bool } from 'prop-types';
import Icon from 'components/icon';

export default function SingleCheckboxFilter({ filter, classModifier, isChecked, toggleFilters }) {
    return (
        <div className={`single-checkbox-filter ${classModifier}`}>
            <div
                onClick={e => toggleFilters(e, filter, filter.values[0])}
                onKeyPress={e => toggleFilters(e, filter, filter.values[0])}
                role="checkbox"
                aria-checked={isChecked ? 'true' : 'false'}
                tabIndex="0"
                className={`single-checkbox-filter-item ${isChecked ? 'active' : ''}`}
            >
                <Icon glyph="tick" />
                <span>{filter.label}</span>
            </div>
        </div>
    );
}

SingleCheckboxFilter.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    filter: shape({
        code: string.isRequired,
        label: string.isRequired,
        values: arrayOf(bool).isRequired
    }).isRequired,
    classModifier: string,
    isChecked: bool.isRequired,
    toggleFilters: func.isRequired
    /* eslint-enable react/no-typos */
};

SingleCheckboxFilter.defaultProps = { classModifier: '' };
